import React from 'react'

import { useStoreContext } from '../../../contexts/StoreContext'

function FooterAppLinks() {
  const { loyaltyClubDownloadImages } = useStoreContext()

  const iOSAppLink = loyaltyClubDownloadImages?.iOSAppLink
  const iOSAppButton = loyaltyClubDownloadImages?.iOSAppButton
  const androidAppLink = loyaltyClubDownloadImages?.androidAppLink
  const androidAppButton = loyaltyClubDownloadImages?.androidAppButton

  if (!iOSAppLink || !iOSAppButton || !androidAppLink || !androidAppButton) {
    return null
  }

  return (
    <>
      <div className="footer-app-container">
        <h2 className="footer-tittle-app">Baixe nosso app </h2>
        <div className="footer-content-app">
          <div className="footer-button-download-app">
            <a href={iOSAppLink} target="_blank" rel="noopener noreferrer">
              <img src={iOSAppButton} alt="Download AppStore" />
            </a>
            <a href={androidAppLink} target="_blank" rel="noopener noreferrer">
              <img src={androidAppButton} alt="Download PlayStore" />
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default FooterAppLinks
